import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { Link } from "gatsby"
import * as styles from "./Navbar.module.css"
const NavLinks = props => (
  <div className={styles.navlinks_container}>
    <ul className={styles.links_wrapper}>
      <li className={styles.link_item}>
        <Link to="/">Home</Link>
      </li>
      <li className={styles.link_item}>
        <div className={styles.dropdown}>
          Choose Your Field
          <div className={styles.dropdownContent}>
            <Link to="/Core">Core</Link>
            <Link to="/Consultancy">Consultancy</Link>
            <Link to="/Entrepreneurship">Entrepreneurship</Link>
            <Link to="/Finance">Finance</Link>
            <Link to="/IT">IT</Link>
            <Link to="/Miscellaneous">Miscellaneous</Link>
            <Link to="/Product Management">Product Management</Link>
            <Link to="/Research">Research</Link>
            <Link to="/Supply Chain Management">Supply Chain Management</Link>
          </div>
        </div>
      </li>
      <li className={styles.link_item}>
        <Link to="/testimonials">Testimonials</Link>
      </li>
      <li className={styles.link_item}>
        <Link to="/about">About Us</Link>
      </li>
      <li className={styles.link_item}>
        <AnchorLink to="/#contactus">Contact Us</AnchorLink>
      </li>
    </ul>
  </div>
)
export default NavLinks
